import { SharedDocumentApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useSharedDocumentApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(() => new SharedDocumentApi(configuration), [configuration]);
};
